import React from 'react';
import EstimatesLandingPage from 'containers/estimates/EstimatesLandingPage';

const EstimatesPage: React.FC = () => {
  return <EstimatesLandingPage />;
};

export default EstimatesPage;
